/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBanPopoverContainer_story = {
    readonly id: string;
    readonly site: {
        readonly id: string;
        readonly name: string;
    };
    readonly " $refType": "UserBanPopoverContainer_story";
};
export type UserBanPopoverContainer_story$data = UserBanPopoverContainer_story;
export type UserBanPopoverContainer_story$key = {
    readonly " $data"?: UserBanPopoverContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBanPopoverContainer_story">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "UserBanPopoverContainer_story",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Site",
                "kind": "LinkedField",
                "name": "site",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Story",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '494f4436abc7ce438d26c27ff5030a42';
export default node;
